import "../k";
import { loadLevelAssets, getLevelSpec } from "../cloudLoader";
import { addButton } from "../things/button";
import { goTransition } from "../util/goTransition";
import { QUIZ_GREEN } from "../util/style";

scene("levelLoading", (levelIndex: number, folderName: string) => {
  const centerX = width() / 2;
  const centerY = height() / 2;

  const spec = getLevelSpec(folderName);
  const levelName = spec?.name || folderName;

  // Back button
  const backButton = addButton("back", [pos(100, 100), "backButton"]);
  backButton.onClick(() => {
    goTransition("levelSelect");
  });

  // Level name
  add([
    text(levelName, { size: 36, font: "rumeur" }),
    pos(centerX, centerY - 80),
    anchor("center"),
    color(BLACK),
  ]);

  // Loading text
  add([
    text("Loading...", { size: 28, font: "rumeur" }),
    pos(centerX, centerY - 20),
    anchor("center"),
    color(BLACK),
  ]);

  // Progress bar background
  const barWidth = 400;
  const barHeight = 24;
  add([
    rect(barWidth, barHeight, { radius: 12 }),
    pos(centerX, centerY + 40),
    anchor("center"),
    color(60, 60, 60),
  ]);

  // Progress bar fill
  const progressBar = add([
    rect(0, barHeight - 8, { radius: 8 }),
    pos(centerX - barWidth / 2 + 4, centerY + 40),
    anchor("left"),
    color(QUIZ_GREEN),
  ]);

  // Status text
  const statusText = add([
    text("Downloading assets...", { size: 18, font: "rumeur" }),
    pos(centerX, centerY + 90),
    anchor("center"),
    color(150, 150, 150),
  ]);

  // Error state
  let hasError = false;

  // Start loading assets
  loadLevelAssets(folderName, (progress) => {
    if (!hasError) {
      progressBar.width = Math.max(0, (barWidth - 8) * progress);
    }
  })
    .then(() => {
      statusText.text = "Ready!";
      wait(0.2, () => {
        go("levelIntro", levelIndex);
      });
    })
    .catch((error) => {
      hasError = true;
      console.error("Failed to load level assets:", error);
      statusText.text = "Failed to load. Click to retry.";
      statusText.color = rgb(255, 100, 100);

      onClick(() => {
        goTransition("levelLoading", levelIndex, folderName);
      });
    });
});
